// extracted by mini-css-extract-plugin
export default {"section":"styles_section__MpKXG","calculationListing":"styles_calculationListing__YC5rR","projectPage":"styles_projectPage__3aINN","listing":"styles_listing__lLLm6"};